import { UPDATE_TRACKER_INSTALLATION_TYPE } from '../actions/pwn-tracker';

const initialState = {
    signedIn: undefined,
    loggedOut: false,

    roles: [],

    email: null,
    enterpriseId: undefined,
    enterpriseMismatch: false,

    submitted: false,

    locations: {},
    locationId: undefined, // selected location object id
    locationName: undefined, // selected location name

    functionsLimited: false,
    enabledFunctions: [],
    trackerInstallationType: '',

    showBanner: false, // Flag to show NHN banner

    // error
    message: undefined,
    form: {}
};

function authReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'SESSION_REQUEST':
            return state;

        case 'SESSION_RESULTS':
            return {
                ...state,
                ...action.auth
            };
        case 'LOGIN_TIME':
            return {
                ...state,
                loginTime: action.time
            };

        case 'SET_SHOW_BANNER':
            return {
                ...state,
                showBanner: action.show
            };

        case 'LOGIN_REQUEST':
            return {
                ...initialState,
                user: action.user,
                signedIn: false,
                submitted: true
            };

        case 'LOGIN_SUCCESS':
            return {
                ...state,
                submitted: false,
                loggedOut: false,
            };

        case 'LOGIN_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'LOGIN_FORM_VALIDATION':
            return {
                ...state,
                submitted: false,
                form: {
                    ...state.form,
                    ...action.form
                }
            };

        case 'LOGOUT_SUCCESS':
            return {
                ...initialState,
                loggedOut: true,
                signedIn: false
            };
        case 'LOGOUT_ERROR':
            return {
                ...initialState,
                signedIn: false
            };

        case 'LOGIN_UNLOAD_PAGE':
            return {
                ...state,
                form: {},
                message: undefined
            };

        case 'LOCATION_SUCCESS':
            return {
                ...state,
                locations: {
                    ...action.locations
                },
                locationId: action.selectedId,
                locationName: action.selectedName,
                functionsLimited: action.functionsLimited,
                enabledFunctions: action.enabledFunctions
            };

        case 'LOCATION_SELECTION':
            return {
                ...state,
                locationId: action.selectedId,
                locationName: state.location[action.selectedId]
            };

        case 'LOCATION_CLEAR':
            return {
                ...state,
                locations: {},
                locationId: undefined,
                locationName: undefined
            };
        case UPDATE_TRACKER_INSTALLATION_TYPE:
            return {
                ...state,
                trackerInstallationType: action.payload
            };

        default:
            return state;
    }
}

export default authReducer;
